import React from 'react';
import UserProfile from '../../components/profile/userProfile/UserContent'

export default function Profile() {
    return (
        <>
            <UserProfile />
        </>
    )
}